import { useSearchParams } from 'react-router-dom';
import { usePagination } from '../../../hooks/use-pagination';
import { OfferListFilter } from '../constants/offer-list-filter.enum';
import { OFFERS_PAGE_SIZE, OFFERS_SEARCH_PARAM } from '../constants/offers-page.constants';
import { isOfferListFilter } from '../lib/enum-guards';

/** Offer filter + page, both kept in the URL (same pattern as `products/hooks/use-archive-list-params.ts`). */
export const useOfferListParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pagination, isValidPagination, handlePaginationChange, resetPaginationOnSearchParamsChange } = usePagination({
    pageSize: OFFERS_PAGE_SIZE,
    pageParamName: OFFERS_SEARCH_PARAM.page
  });

  const rawFilter = searchParams.get(OFFERS_SEARCH_PARAM.filter);
  const filter = isOfferListFilter(rawFilter) ? rawFilter : OfferListFilter.OPEN;

  const handleFilterChange = (next: OfferListFilter) => {
    if (next === filter) return;
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set(OFFERS_SEARCH_PARAM.filter, next);
      return resetPaginationOnSearchParamsChange(params);
    });
  };

  return { filter, handleFilterChange, pagination, isValidPagination, handlePaginationChange };
};
